export default {
  accountCreated:
    'Your account was created. Please check your e-mail and follow the validation procedure. Once this is done, you will be able to configure your account. Have fun setting everything up!',
  FAILED_TO_ACTIVATE:
    'Something happend and we could not activate your account. Please check your e-mail or contact our support team at contact@sportya.net',
  SUCCESSFULLY_ACTIVATED:
    'Congrats! You have succesfully activated your account. You can now log in to continue your account set up!',
};
